import { render, staticRenderFns } from "./UnderlineTextIcon.vue?vue&type=template&id=65b5becc&scoped=true"
import script from "./UnderlineTextIcon.vue?vue&type=script&lang=js"
export * from "./UnderlineTextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5becc",
  null
  
)

export default component.exports